import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Inject, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { GridModule } from '@progress/kendo-angular-grid';
import * as XLSX from 'xlsx';
import { oktaToken } from '../../../../models/okta-token.model';
import { setting } from '../../models/setting.model';
import { CommonService } from '../../../question/services/commonservice';
import { SettingService } from '../../services/settingservice';

import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';

// Import ISG Shared Components
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid';
import { GridColumnFactory } from '@mysrc/app/shared/utils/grid-column-factory';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { dateValueFormatter } from '@mysrc/app/shared/utils/date-formatter';




@Component({
  selector: 'setting',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, GridModule, NgbModule, AgGridAngular, IsgGridComponent],
  templateUrl: './page-setting.component.html',
  styleUrls: ['./page-setting.component.css'],
  providers: [CommonService, SettingService, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageSettingComponent extends BaseHttpReqRespService {

  @ViewChild('deleteSettingModelConfirmation') deleteSettingModelConfirmation!: TemplateRef<any>;
  @ViewChild('settingModal') settingModal!: TemplateRef<any>;

  modalRef: NgbModalRef | undefined;
  success: boolean = false;

  settingForm!: FormGroup;
  public settinglist!: setting[];

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true
  };

  // ISG Grid configuration for consistent styling
  gridConfig: Partial<IsgGridConfig> = {
    height: '500px',
    pagination: true,
    pageSize: 10,
    autoSizeColumns: true
  };

  public successOrFailureMessage: string = '';
  myAppUrl: any;
  public currentDeleteId: number = 0;

  arrayBuffer: any;
  file: File | null = null;

  errorMessage: any;
  fileName: string = '';
  public fromPage: string = 'Question';
  public oktaTokenDetails!: oktaToken;

  public gridPageSize = 10;
  public gridSkip = 0;

  constructor(
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    protected http: HttpClient,
    private EncrDecr: EncrDecrService,
    private _router: Router,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private renderer: Renderer2,
    private _date: DatePipe,
    private modalService: NgbModal,
    private settingService: SettingService,
    @Inject('BASE_URL') baseUrl: string // <-- add this
  ) {
    super(http, oauth);
    this.myAppUrl = baseUrl; // <-- add this
  }

  ngOnInit() {

    this.AddNew();
    this.getSettingList();
  }

  openAddSettingModal(content: any): void {
    this.AddNew();
    this.modalRef = this.modalService.open(content, {
      //size: 'lg',
      backdrop: 'static', // prevents accidental close
      keyboard: false,    // disables ESC close
      //centered: true,
      modalDialogClass: 'modal-primary'
    });
  }

  public saveSetting() {

    //let model = "model=" + JSON.stringify(this.settingForm.value);
    let model = JSON.stringify(this.settingForm.value);
    this.settingService.saveSetting(this.settingForm.value).subscribe(result => {
      this.settinglist = result;
      this.successOrFailureMessage = "Setting saved successfully.";
      this.messageTimeout();
      this.settingForm.reset();
    }, error => console.error(error));
  };

  messageTimeout() {
    window.setTimeout(() => {
      this.successOrFailureMessage = '';
    }, 2500);
  }
  onGridReady(params :any) {
    params.api.sizeColumnsToFit();
  }

  getSettingList() {
    let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');

    this.settingService.getsettinglist(workspaceId).subscribe({
      next: (result: any[]) => {
        this.settinglist = result;
      }
    })
    //this.hideMessage();
  }

  hideMessage() {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) divMessage.style.display = "none";
    var message = document.getElementById('message');
    if (message) message.innerText = '';
  }

  AddNew() {

    this.settingForm = this.formBuilder.group({
      //'settingName': new FormControl('', Validators.compose([Validators.required, this.noWhitespaceValidator])),
      'settingName': new FormControl('', Validators.required),
      'settingId': 0,
    });

  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  AddSettings() {
    this._router.navigate(['/createsettings']);
  }

  CloseForm() {
    this.settingForm.reset();
  }

  linkRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const attr = this.renderer.createText(params.value);
    this.renderer.appendChild(element, attr);
    this.renderer.setAttribute(element, 'href', 'javascript:void(0)');
    this.renderer.setAttribute(element, 'value', params.data.settingId);
    this.renderer.listen(element, 'click', () => {
      this.settingService.onEditSetting(params).subscribe({
        next: (response: any) => {
          // If response is an array, use response[0]
          const data = Array.isArray(response) ? response[0] : response;
          this.settingForm.patchValue({
            'settingName': data.settingName,
            'settingId': data.settingId,
          });
          // Open the modal programmatically
          this.openAddSettingModal(this.settingModal);
        },
        error: (error: any) => {
          console.log(error);
        }
      });
      return true;
    });
    return element;
  }

  //columnDefs = [

  //  //{ headerName: 'SettingId', field: 'settingId', hide: true },
  //  { headerName: 'Setting Name', field: 'settingName', cellRenderer: this.linkRenderer.bind(this), resizable: true },
  //  //{ headerName: 'Manage Sections', cellRenderer: this.SettingSectionMapCellRenderer.bind(this), resizable: true },
  //  { headerName: 'Created By', field: 'createdByName', resizable: true },
  //  { headerName: 'Modified By', field: 'modifiedByName', resizable: true },
  //  { headerName: 'Created Date', field: 'createdDate', cellRenderer: (data:any) => { return data.value ? (new Date(data.value)).toLocaleDateString() : ''; }, resizable: true },
  //  { headerName: 'Modified Date', field: 'modifiedDate', cellRenderer: (data:any) => { return data.value ? (new Date(data.value)).toLocaleDateString() : ''; }, resizable: true },
  //  { headerName: 'Settings', field: 'sectionSettings', cellRenderer: this.SurveySectionSettingsRenderer.bind(this), resizable: true },
  //  //{ headerName: 'Delete', cellRenderer: this.deleteImageRenderer.bind(this), resizable: true },

  //];

  columnDefs: ColDef[] = [

    {
      headerName: 'SettingId',
      field: 'settingId',
      hide: true
    },

    {
      headerName: 'Setting Name',
      field: 'settingName',
      cellRenderer: (params: any) => this.linkRenderer(params)
    },

    {
      headerName: 'Manage Sections',
      cellRenderer: (params: any) => this.SettingSectionMapCellRenderer(params)
    },

    {
      headerName: 'Created By',
      field: 'createdByName'
    },

    {
      headerName: 'Modified By',
      field: 'modifiedByName'
    },

    {
      headerName: 'Created Date',
      field: 'createdDate',
      width: 120,
      valueFormatter: dateValueFormatter
    },

    {
      headerName: 'Modified Date',
      field: 'modifiedDate',
      width: 120,
      valueFormatter: dateValueFormatter
    },

    //{
    //  headerName: 'Settings',
    //  field: 'sectionSettings',
    //  cellRenderer: (params: any) => this.SurveySectionSettingsRenderer(params)
    //},

    {
      headerName: 'Delete',
      cellRenderer: (params: any) => this.deleteImageRenderer(params),
      width: 100
    }

  ];

  //SurveySectionSettingsRenderer(params: any) {
  //  const mainElement = this.renderer.createElement('div');

  //  const anchor = this.renderer.createElement('a');
  //  const icon = this.renderer.createElement('i');

  //  icon.setAttribute('class', 'fa fa-cogs anchor-cursor p-2');
  //  icon.setAttribute('title', 'Language Settings');

  //  this.renderer.appendChild(anchor, icon);
  //  this.renderer.appendChild(mainElement, anchor);

  //  this.renderer.listen(anchor, 'click', () => {
  //    this._router.navigate([
  //      'surveysectionlanguagesettings',
  //      { sectionId: params.data.sectionId }
  //    ]);
  //  });

  //  return mainElement;
  //}

  deleteImageRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa  fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);

    this.renderer.listen(element, 'click', () => {
      this.currentDeleteId = params.data.settingId;
      // Open the modal programmatically
      this.openDeleteSettingModal();
    });
    return element;
  }

  // Add this method to your component:
  openDeleteSettingModal() {
    // Assumes you have @ViewChild('deleteSettingModelConfirmation') deleteSettingModelConfirmation!: TemplateRef<any>;
    this.modalRef = this.modalService.open(this.deleteSettingModelConfirmation, {
      backdrop: 'static',
      keyboard: false
    });
  }

  deleteSetting() {
    let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    
    this.settingService.deleteSetting(this.currentDeleteId, workspaceId).subscribe({
      next: (result: any) => {
        this.settinglist = result.listOfSettings;
        this.successOrFailureMessage = result.messageInfo;
        this.messageTimeout();
      },
      error: (error: any) => console.error(error)
    })
     
  }

  SettingSectionMapCellRenderer(params:any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa  fa-list-alt anchor-cursor');
    this.renderer.appendChild(element, elementI);



    this.renderer.listen(element, 'click', () => {
      var settingId = params.data.settingId;
      var settingName = params.data.settingName;
      this._router.navigate(['/createsettings'], { queryParams: { settingId: settingId, settingName: settingName } });
    });
    return element;

  }

  onGridPageChange(event: any) {
    this.gridSkip = event.skip;
    this.gridPageSize = event.pageSize;
  }
}

